var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbacks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.999,
    cy: 45,
    r: 44,
    fill: "white",
    stroke: "#B9D7FF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3801 20.7701H31.2295C25.6636 20.7701 21.1354 25.2983 21.1354 30.8642V56.8142C21.1354 58.4151 22.0136 59.8808 23.4247 60.6378C24.0667 60.9831 24.7713 61.1526 25.4738 61.1526C26.3137 61.1526 27.1515 60.9084 27.8783 60.4259L35.8789 55.0901H47.3801C52.946 55.0901 57.4742 50.5619 57.4742 44.996V30.8642C57.4742 25.2983 52.946 20.7701 47.3801 20.7701Z",
    fill: "#00226F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8628 38.9394V64.8894C68.8628 66.4903 67.9846 67.956 66.5735 68.7131C65.9315 69.0583 65.2269 69.2279 64.5244 69.2299C63.6845 69.2299 62.8467 68.9856 62.122 68.5031L54.1193 63.1653H42.6181C39.6908 63.1653 37.0724 61.8915 35.2272 59.8948L36.3759 59.1277H46.6557C54.4464 59.1277 60.7875 52.7866 60.7875 44.9959V30.8641C60.7875 30.2424 60.733 29.6367 60.6563 29.0351C65.3218 29.9234 68.8628 34.0196 68.8628 38.9394Z",
    fill: "#4A90E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbacks);
export default __webpack_public_path__ + "static/media/feedbacks.ac0422d6f64f4bc389f618c129912e39.svg";
export { ForwardRef as ReactComponent };